import { Component } from '@angular/core';
import {NgForOf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-our-customers',
  imports: [
    NgForOf,
    TranslatePipe
  ],
  templateUrl: './our-customers.component.html',
  styleUrl: './our-customers.component.scss'
})
export class OurCustomersComponent {
  public customers = [
    {
      id: 2,
      logo: 'assets/images/delegates.webp',
      title: 'Delegates',
      url: 'https://www.delegatecourier.eu/'
    },
    {
      id: 3,
      logo: 'assets/images/fornext.png',
      title: 'Fornext',
      url: 'https://www.lebosol.de/bg'
    },
    {
      id: 1,
      logo: 'assets/images/fairpoint.png',
      title: 'Fair Point',
      url: 'https://www.fair-point.com'
    },
    {
      id: 3,
      logo: 'assets/images/lebosol.svg',
      title: 'Lebosol',
      url: 'https://www.lebosol.de/bg'
    },
    {
      id: 4,
      logo: 'assets/images/varshets.webp',
      title: 'Visit Varshets',
      url: 'https://play.google.com/store/apps/details?id=com.iphos.visitvarshets.app'
    },
    {
      id: 5,
      logo: 'assets/images/iphos.png',
      title: 'Iphos',
      url: 'https://www.iphos.com/'
    }
  ]
}
